/* eslint-disable react/no-string-refs */
import React from 'react';

// Make group for face '.fill--face'
// Make glasses target 'ref="glassesTarget"'
// Make groups for each eye group
// - '.fill-eyes eyes'
// - '.fill-face eyes--blink'
// - '.fill-face eyes--is-being-pet--likes'
// - '.fill-eyes eyes--is-being-pet--hates'

export default class Eyes extends React.Component {
	componentDidMount() {
		this.props.getGlassesTargetCoords(this.refs.glassesTarget);
	}
	render() {
		return (
			<g className="fill--face pig-face">
				<circle ref="glassesTarget" cx="187.35" cy="271.18115" r="0" />
				<g className="fill--eyes eyes">
					<ellipse cx="157.60091" cy="271.87469" rx="6.93353" ry="7.70392" />
					<ellipse cx="217.51982" cy="271.87469" rx="6.92918" ry="7.69909" />
				</g>
				<g className="fill--face eyes--blink">
					<path d="M210.61174,276.63022c-0.94312-0.23715-1.61465-1.11777-1.55447-2.12411c0.06749-1.13791,1.04489-2.00589,2.18283-1.93839
						l12.80632,0.76022c1.13774,0.0683,2.00629,1.04501,1.93791,2.18314c-0.0675,1.13794-1.04491,2.00589-2.18283,1.93839
						l-12.80634-0.76022C210.86327,276.68143,210.73529,276.66132,210.61174,276.63022z" />
					<path d="M164.50998,276.63022c0.9431-0.23715,1.61464-1.11777,1.55447-2.12411c-0.06749-1.13791-1.04489-2.00589-2.18283-1.93839
						l-12.80632,0.76022c-1.13774,0.0683-2.00629,1.04501-1.93791,2.18314c0.06749,1.13794,1.04489,2.00589,2.18283,1.93839
						l12.80632-0.76022C164.25845,276.68143,164.38641,276.66132,164.50998,276.63022z" />
				</g>
				<g className="fill--face eyes--is-being-pet--likes">
					<path d="M163.90364,276.09586c-0.49915,0-0.99908-0.17981-1.39581-0.54431c-0.75879-0.69669-2.39731-1.48489-4.72124-1.60706
						c-2.32233-0.11774-4.03584,0.49066-4.86316,1.10471c-0.91684,0.68018-2.20863,0.48785-2.88759-0.42697
						c-0.67976-0.91522-0.48865-2.20822,0.42657-2.88797c1.84494-1.37003,4.58334-2.06873,7.54027-1.91269
						c2.94644,0.15482,5.60663,1.13535,7.29837,2.69c0.83942,0.7713,0.89507,2.07721,0.12338,2.91663
						C165.01721,275.87128,164.46164,276.09586,163.90364,276.09586z" />
					<path d="M211.2171,276.09589c-0.55801,0-1.11359-0.22455-1.5208-0.66766c-0.7717-0.83942-0.71605-2.14532,0.12337-2.9166
						c1.69174-1.55466,4.35193-2.53519,7.29837-2.69003c2.94887-0.15643,5.69533,0.54269,7.54028,1.91269
						c0.91521,0.67978,1.10632,1.97278,0.42656,2.888c-0.68057,0.91562-1.97316,1.1051-2.88757,0.42694
						c-0.82652-0.61401-2.52956-1.22284-4.86316-1.10471c-2.32393,0.12216-3.96246,0.9104-4.72125,1.60709
						C212.21617,275.91608,211.71623,276.09589,211.2171,276.09589z" />
				</g>
				<g className="fill--eyes eyes--is-being-pet--hates">
					<path d="M164.53444,271.87946c0.00156,4.25476-3.10954,6.66882-6.93883,6.6662s-6.92668-2.42096-6.92824-6.67572
						c-0.00137-3.79651,3.10954-3.56992,6.93883-3.56729C161.43549,268.3053,164.53304,268.07343,164.53444,271.87946z" />
					<path d="M210.59064,271.87946c0.0013,4.25211,3.10759,6.664,6.93448,6.66138c3.82687-0.00262,6.92505-2.41879,6.92389-6.6709
						c-0.00104-3.79651-3.10759-3.56509-6.93446-3.56244C213.68765,268.31012,210.58949,268.07343,210.59064,271.87946z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Pig/Eyes.js